import React from "react";
import { StyledVehicleSection } from "./styled";
import { useFlags } from "launchdarkly-react-client-sdk";

interface VehicleSectionProps {
  activeCTA: boolean;
  children: React.ReactNode;
  isSwitchCtaAvailable: boolean;
}

const VehicleSection = ({
  activeCTA,
  children,
  isSwitchCtaAvailable
}: VehicleSectionProps) => {
  const { ciGuidelinesRollout } = useFlags();

  return (
    <StyledVehicleSection
      activeCTA={activeCTA}
      ciGuidelinesRollout={ciGuidelinesRollout}
      isSwitchCtaAvailable={isSwitchCtaAvailable}
    >
      {children}
    </StyledVehicleSection>
  );
};

export default VehicleSection;